import { createFileRoute } from "@tanstack/react-router";
import { MyPageView } from "@/views/mypage";

export const Route = createFileRoute("/_content/mypage")({
  component: MyPageView,
});
